// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Image/novus_loyalty_logo_white.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Image/novus_loyalty_logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../Image/pci-dss.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nvsbanner {
  background: linear-gradient(to right, #006bc0, #691dc0);
}

.nvs_banner_container {
  padding: 130px 0 80px 100px;
}

.nvs_banner_container h1 {
  color: #FFF;
  font-weight: 900;
  font-size: 36px;
}

.bigspacing {
  padding: 80px 0;
}

.smallspacing {
  padding: 40px 0;
}

.nvfooter ul {
  padding: 0;
  margin: 0;
}
.nvfooter ul li {
  list-style: none;
}

.wid900 {
  width: 900px;
  margin: 0 auto;
}

.ttbg {
  background-color: #faf9fc;
}

.ppbg {
  background-color: #f5f4fa;
}

.tncbox ol {
  counter-reset: item;
  padding: 0;
}
.tncbox ol li {
  display: block;
  position: relative;
  font-family: "Gilroy Medium";
  margin-bottom: 40px;
}
.tncbox ol li h3 {
  font-size: 24px;
  margin-left: 30px;
  margin-bottom: 15px;
  font-weight: 700;
}
.tncbox ol li h4 {
  font-weight: 500;
}
.tncbox ol li h5 {
  font-weight: 500;
  margin-bottom: 15px;
}
.tncbox ol li ol li {
  page-break-inside: avoid;
  break-inside: avoid;
  text-align: justify;
  font-family: "Gilroy Light";
  margin-left: 50px;
  font-size: 16px;
  margin-bottom: 15px;
}
.tncbox ol li ol li ul li {
  list-style: disc;
  margin-left: 20px;
  margin-top: 10px;
}
.tncbox ol li ol li:before {
  margin-left: -50px;
  font-family: "Gilroy Light";
  font-size: 16px;
  top: 3px;
}
.tncbox ol li:before {
  content: counters(item, ".") ".";
  counter-increment: item;
  position: absolute;
  left: 0;
  font-family: "Gilroy Medium";
  font-size: 24px;
  top: -2px;
}
.tncbox ul li:before {
  display: none;
}

.tncbox ol .termsAndCondition__list li {
  font-family: "Gilroy Light";
}
.tncbox ol .termsAndCondition__list li:before {
  font-size: 24px;
  line-height: 1.2;
  top: 0;
}

@media screen and (max-width: 768px) {
  .wid900 {
    width: 100%;
  }
  .tncbox {
    padding-bottom: 40px !important;
  }
  .termsAndCondition__list li {
    padding-left: 0 !important;
  }
  .termsAndCondition__list li h3 {
    padding-left: 40px !important;
  }
  .termsAndCondition__list ol li {
    padding: 0;
  }
}
.navbar {
  background: transparent;
  padding: 0;
  height: 100px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999999;
  transition: background 150ms cubic-bezier(0.645, 0.045, 0.355, 1);
}

.navbar .navbar-brand {
  height: 100px;
  line-height: 100px;
  padding: 20px 0;
}

.navbar .nl_logo, .hidebig .nl_logo {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  display: inline-block;
  width: 144px;
  height: 60px;
}

.hidebig .nl_logo {
  margin: 10px 0 0 10px;
}

.navbar.sticky {
  top: 0;
}

.navbar.sticky .nl_logo, .navbar.white .nl_logo {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  display: inline-block;
  width: 144px;
  height: 60px;
}

.navbar.sticky, .navbar.white {
  background: #fff;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.06);
}

.navbar-menu {
  position: relative;
  float: right;
}

.navbar-menu .navigation_box ul {
  margin-bottom: 0;
}

.navigation_box ul li {
  display: inline-block;
  position: relative;
}

.navigation_box ul li a {
  padding: 0 15px;
  color: #FFF;
  display: block;
  position: relative;
}

.navbar.sticky .navigation_box ul li a, .navbar.white .navigation_box ul li a {
  color: #0a6ebe;
}

.navigation_box a.bookdemo {
  background: #ff9900;
  padding: 10px 20px;
  border-radius: 30px;
  border: 1px solid #ff9900;
  text-transform: uppercase;
  font-weight: 500;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  margin-right: 15px;
}

.navigation_box a.tryforfreebtn {
  background: transparent;
  padding: 10px 20px;
  border-radius: 30px;
  border: 1px solid #FFF;
  text-transform: uppercase;
  font-weight: 500;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.navigation_box a.bookdemo:hover {
  background: #ec8f04;
}

.navbar.sticky .navigation_box a.bookdemo, .navbar.white .navigation_box a.bookdemo {
  color: #FFF;
  background: #0a6ebe;
  border-color: #0a6ebe;
  animation: fade-shadow 6s infinite;
}

.navbar.sticky .navigation_box a.tryforfreebtn, .navbar.white .navigation_box a.tryforfreebtn {
  border-color: #0a6ebe;
}

.arrow {
  border: solid #fbfaff;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  margin: 0 0 3px 3px;
  transition: all 0.5s ease-in-out;
}

.right {
  transform: rotate(-455deg);
  -webkit-transform: rotate(-45deg);
  margin: 0 0 3px 3px;
  transition: all 0.5s ease-in-out;
}

.navbar.sticky .navigation_box ul li a i.arrow, .navbar.white .navigation_box ul li a i.arrow {
  border-color: #0a6ebe;
}

.navigation_box ul li .customDropDown {
  position: absolute;
  top: 100%;
  left: 0;
  padding: 0;
  width: 240px;
  text-align: left;
  margin-top: 40px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(100px);
  transition: all 650ms cubic-bezier(0.76, 0, 0.11, 1);
  transition-timing-function: cubic-bezier(0.76, 0, 0.31, 1);
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 10px;
}

.navigation_box ul li:hover .customDropDown {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.navigation_box ul li:hover a i.arrow.down {
  transform: rotate(225deg);
}

.navigation_box ul li .customDropDown li {
  display: block;
  font-size: 13px;
  padding: 0 15px;
  line-height: 20px;
  background: #FFF;
}

.navigation_box ul li .customDropDown li a {
  font-family: "Gilroy Medium";
  color: #000;
  padding: 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
  font-size: 14px;
}

.navigation_box ul li .customDropDown li:first-child {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.navigation_box ul li .customDropDown li:last-child {
  border-bottom: none;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.navigation_box ul li .customDropDown li:last-child a {
  border-bottom: none;
}

.navbar.sticky .navigation_box ul li .customDropDown li a, .navbar.white .navigation_box ul li .customDropDown li a {
  color: #000;
}

@keyframes fade-shadow {
  0% {
    box-shadow: 0 0 0 0 rgb(244, 244, 244);
  }
  10% {
    box-shadow: 0 0 0 0 rgb(244, 244, 244);
  }
  100% {
    box-shadow: 0 0 0 10px rgb(244, 244, 244);
  }
}
.navigation_box ul li .customDropDown li .customDropDownSub {
  position: absolute;
  top: 0;
  left: 100%;
  padding: 0;
  width: 240px;
  text-align: left;
  opacity: 0;
  visibility: hidden;
  transform: translateY(100px);
  transition: all 650ms cubic-bezier(0.76, 0, 0.11, 1);
  transition-timing-function: cubic-bezier(0.76, 0, 0.31, 1);
  margin-left: 3px;
  box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
  border-radius: 10px;
}

.navigation_box ul li .customDropDown li:hover .customDropDownSub {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.customDropDown li a i.arrow {
  border-color: #000;
  float: right;
  margin-top: 7px;
  border-width: 0 2px 2px 0;
}

.navigation_box ul li .customDropDown li:hover {
  background: #006bc0;
}

.navigation_box ul li .customDropDown li:hover a {
  color: #FFF;
}

.navigation_box ul li .customDropDown li:hover a i.arrow {
  border-color: #FFF;
}

.navigation_box ul li .customDropDown li:hover .customDropDownSub li a {
  color: #000;
}

.navigation_box ul li .customDropDown li:hover .customDropDownSub li:hover a {
  color: #fff;
}

.navbar.sticky .navigation_box ul li .customDropDown li:hover, .navbar.white .navigation_box ul li .customDropDown li:hover {
  background: #006bc0;
}

.navbar.sticky .navigation_box ul li .customDropDown li:hover a, .navbar.white .navigation_box ul li .customDropDown li:hover a {
  color: #FFF;
}

.navbar.sticky .navigation_box ul li .customDropDown li:hover .customDropDownSub li a, .navbar.white .navigation_box ul li .customDropDown li:hover .customDropDownSub li a {
  color: #000;
}

.navbar.sticky .navigation_box ul li .customDropDown li:hover .customDropDownSub li:hover a, .navbar.white .navigation_box ul li .customDropDown li:hover .customDropDownSub li:hover a {
  color: #fff;
}

.header_space {
  margin-top: 100px;
}

.header_logo {
  position: relative;
  z-index: 1;
  float: left;
  padding: 4px 0;
}

.header_logo a {
  display: block;
  width: 150px;
  height: 80px;
  outline: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  background-size: 100%;
  margin-top: 15px;
}

.navigation_links {
  height: 100px;
  line-height: 100px;
}

.navigation_links ul {
  margin-left: 100px;
  float: right;
}

.navigation_links ul li {
  display: inline-block;
}

.navigation_links ul li a {
  color: #000;
  text-transform: uppercase;
  padding: 15px 15px;
}

.navigation_links ul li a.client_login {
  padding: 10px 30px;
  border: 1px solid #006bc0;
  border-radius: 30px;
}

.navigation {
  transition: all 0.5s ease;
}

.navigation_logo {
  width: 100px;
  margin: 15px 15px 10px;
}

div.bookdemomobbox {
  display: none;
}

@media only screen and (max-width: 768px) {
  div.bookdemomobbox {
    display: block;
  }
  div.bookdemomobbox ul li {
    display: inline-block;
  }
  div.bookdemomobbox ul li.menuBtn {
    display: inline-block;
  }
  div.bookdemomobbox .menuBtn {
    display: inline-block;
  }
  div.bookdemomobbox .menuBtn a {
    position: relative;
    top: 7px;
  }
}
/*** Footer ***/
.nlgradbg {
  background: linear-gradient(to right, #006bc0, #691dc0);
}

.novus_footer {
  padding: 40px 0;
}

.novus_footer .footer_link_box {
  padding: 0 0 0 60px;
}

.novus_footer .footer_link_box ul li {
  margin-bottom: 15px;
  text-transform: uppercase;
}

.novus_footer .footer_link_box ul li:nth-last-child(1) {
  margin-bottom: 0;
}

.novus_footer .footer_link_box ul li a {
  color: #000;
}

.footer_row {
  margin-top: 60px;
}

.footer_row h5 {
  margin-bottom: 20px;
  font-weight: 700;
  color: #FFF;
}

.footer_row ul li {
  margin: 10px 0;
  font-size: 16px;
}

.footer_row ul li a {
  color: #FFF;
}

.footer_header {
  display: none;
}

.footer_copyright {
  padding: 10px 0;
}

.footer_copyright p {
  margin-bottom: 0;
  color: #ffffff;
  font-family: "Gilroy Light";
}

.footer_copyright ul li {
  display: inline-block;
  margin-right: 30px;
  color: #fff;
}

.footer_copyright ul li:nth-child(5) {
  margin-right: 0;
}

.footer_copyright ul li a {
  color: #fff;
}

.footer_copyright_links {
  float: right;
}

.pci_dss {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  width: 78px;
  height: 38px;
  display: inline-block;
  margin-right: 10px;
}

.linkedinfollow {
  position: relative;
  display: inline-block;
  margin-bottom: 20px;
}

.showonmobonly {
  display: none;
}

/*** New Footer ***/
@media only screen and (min-width: 769px) {
  .nffooterlinks, .nfcopyright {
    display: none;
  }
}
@media only screen and (max-width: 768px) {
  .bigspacing {
    padding: 40px 0;
  }
  .hideonnewfooter {
    display: none;
  }
  .nfnewsletter {
    margin-top: 0;
  }
  .nfnewsletter h6 {
    text-align: center;
    font-size: 18px;
  }
  .nfnewsletter .newsletter_form input {
    width: 100%;
    padding: 15px 20px;
  }
  .nfnewsletter .newsletter_form button {
    margin-top: -44px;
    margin-right: 10px;
  }
  .nffooterlinks {
    margin-top: 20px;
    margin-bottom: 15px;
  }
  .nffooterlinks ul {
    text-align: center;
  }
  .nffooterlinks ul li {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 5px;
  }
  .nffooterlinks ul li a {
    color: #FFF;
    font-size: 1.32rem;
  }
  .nfcopyright {
    text-align: center;
    margin-top: 20px;
  }
  .nfcopyright ul li {
    display: inline-block;
    margin-right: 20px;
    font-size: 1.5rem;
    color: #FFF;
  }
  .navbar-menu ul li {
    display: none;
  }
  .navbar-menu ul li.menuBtn {
    display: block;
  }
  .nvsbanner {
    height: auto;
    background-position: center;
    margin-top: 0;
    padding-top: 100px;
  }
  .nvs_banner_container {
    padding: 40px 20px;
  }
  .nvs_banner_container h1 {
    font-size: 28px;
  }
  .footer_link_list, .boxwithcircle:before, .boxwithcirclereverse:after {
    display: none;
  }
  .footer_row.row-cols-1 > * {
    width: 50%;
    padding-left: 20px;
  }
  .footer_row h5 {
    display: none;
  }
  .footer_row h5.footer_header {
    display: block;
    font-size: 1.6rem;
  }
  .hideonmob, .footer_logo_hide_on_mob {
    display: none;
  }
  .footer_row {
    margin-top: 20px;
  }
  .showonmobonly {
    display: inline-block;
  }
  .navbar .nl_logo, .navbar.sticky .nl_logo, .navbar.white .nl_logo {
    width: 120px;
    height: 50px;
    background-size: contain;
  }
}
/*** Menu Wrapper ***/
@media (min-width: 769px) {
  .menuWrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    z-index: 2;
    overflow-y: scroll;
    overflow-x: hidden;
    visibility: hidden;
  }
  .menuWrapper .circle {
    content: "";
    position: fixed;
    top: 0;
    right: 0;
    width: 60%;
    z-index: -1;
    height: 100%;
    background: rgba(1, 42, 94, 0.88);
    transition: all 50ms cubic-bezier(0.165, 0.84, 0.44, 1);
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .menuWrapper .circle {
    width: 100%;
  }
  .nvsbofferingheadingbox, .nvsblorow {
    padding: 0 30px;
  }
  .nvsbofferingbox {
    height: auto;
  }
}
@media (min-width: 769px) {
  .menuWrapper.showMenu {
    opacity: 1;
    visibility: visible;
  }
  .menuWrapper.showMenu .menuInner {
    opacity: 1;
    visibility: visible;
    transition: all 0.8s ease-out;
  }
  .menuWrapper .navContainer {
    position: absolute;
    top: 50%;
    left: 45%;
    width: 400px;
    margin-top: -75px;
    transform: translateY(-50%);
  }
  .menuWrapper .navContainer ul {
    margin: 0;
  }
  .menuWrapper .navContainer ul li {
    position: relative;
    z-index: 1;
    display: block;
    font-weight: 500;
    font-size: 40px;
    line-height: 60px;
    transition: opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .menuWrapper .navContainer ul li a {
    display: inline-block;
    color: #fff;
    transition: color 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }
}
@media (min-width: 769px) and (max-width: 1366px) {
  .menuWrapper .navContainer ul li a {
    padding-right: 0;
  }
}
@media (min-width: 769px) {
  .menuWrapper .navContainer ul li.hasDropDown:before {
    content: "";
    position: absolute;
    top: 33px;
    left: 340px;
    width: 0;
    height: 1px;
    z-index: -1;
    background: #fff;
    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
}
@media (min-width: 769px) and (max-width: 1199px) {
  .menuWrapper .navContainer ul li.hasDropDown:before {
    top: 27px;
    left: 280px;
  }
}
@media (min-width: 769px) {
  .menuWrapper .navContainer ul li .dropdown {
    position: absolute;
    top: 21px;
    left: 100%;
    padding-left: 0;
    visibility: hidden;
    transition: visibility 10ms ease-out;
    transition-delay: 0.8s;
  }
  .menuWrapper .navContainer ul li .dropdown.adjustUpSide {
    top: -75px;
  }
  .menuWrapper .navContainer ul li .dropdown.adjustUpSide2 {
    top: auto;
    bottom: 0;
  }
  .menuWrapper .navContainer ul li .dropdown li {
    font-weight: 500;
    font-size: 16px;
    opacity: 0;
    margin: 0 0 20px;
    text-align: left;
    line-height: 24px;
    white-space: nowrap;
    text-transform: none;
    transform: translateX(-30%);
    transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1), transform 0.45s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .menuWrapper .navContainer ul li .dropdown li:before {
    display: none;
  }
  .menuWrapper .navContainer ul li .dropdown li:nth-child(1) {
    transition-delay: 780ms;
  }
  .menuWrapper .navContainer ul li .dropdown li:nth-child(2) {
    transition-delay: 740ms;
  }
  .menuWrapper .navContainer ul li .dropdown li:nth-child(3) {
    transition-delay: 0.7s;
  }
  .menuWrapper .navContainer ul li .dropdown li:nth-child(4) {
    transition-delay: 660ms;
  }
  .menuWrapper .navContainer ul li .dropdown li:nth-child(5) {
    transition-delay: 620ms;
  }
  .menuWrapper .navContainer ul li .dropdown li:nth-child(6) {
    transition-delay: 540ms;
  }
  .menuWrapper .navContainer ul li .dropdown li:nth-child(7) {
    transition-delay: 520ms;
  }
  .menuWrapper .navContainer ul li .dropdown li:nth-child(8) {
    transition-delay: 480ms;
  }
  .menuWrapper .navContainer ul li .dropdown li:nth-child(9) {
    transition-delay: 440ms;
  }
  .menuWrapper .navContainer ul li .dropdown li:nth-child(10) {
    transition-delay: 0.4s;
  }
  .menuWrapper .navContainer ul li .dropdown li:nth-child(11) {
    transition-delay: 360ms;
  }
  .menuWrapper .navContainer ul li .dropdown li:nth-child(12) {
    transition-delay: 320ms;
  }
  .menuWrapper .navContainer ul li .dropdown li a {
    background: 0 0;
  }
}
@media (min-width: 769px) and (max-width: 1366px) {
  .menuWrapper .navContainer ul li .dropdown li {
    font-size: 15px;
  }
}
@media (min-width: 769px) and (max-width: 1199px) {
  .menuWrapper .navContainer ul li .dropdown {
    top: 15px;
  }
}
@media (min-width: 769px) {
  .menuWrapper .navContainer ul li:hover.hasDropDown:before {
    width: 40px;
  }
  .menuWrapper .navContainer ul li:hover a {
    color: #fff;
  }
  .menuWrapper .navContainer ul li:hover .dropdown {
    visibility: visible;
    transition-delay: 10ms;
  }
  .menuWrapper .navContainer ul li:hover .dropdown li {
    opacity: 1;
    transform: translateX(0);
  }
  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(1) {
    transition-delay: 340ms;
  }
  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(2) {
    transition-delay: 380ms;
  }
  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(3) {
    transition-delay: 420ms;
  }
  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(4) {
    transition-delay: 460ms;
  }
  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(5) {
    transition-delay: 0.5s;
  }
  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(6) {
    transition-delay: 540ms;
  }
  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(7) {
    transition-delay: 580ms;
  }
  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(8) {
    transition-delay: 620ms;
  }
  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(9) {
    transition-delay: 660ms;
  }
  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(10) {
    transition-delay: 0.7s;
  }
  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(11) {
    transition-delay: 740ms;
  }
  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(12) {
    transition-delay: 780ms;
  }
  .menuWrapper .navContainer ul li:hover .dropdown:hover li a {
    opacity: 0.6;
  }
  .menuWrapper .navContainer ul li:hover .dropdown:hover li a:hover {
    opacity: 1;
  }
}
@media (min-width: 769px) and (max-width: 1199px) {
  .menuWrapper .navContainer ul li {
    font-size: 33px;
    line-height: 60px;
  }
}
@media (min-width: 769px) {
  .menuWrapper .navContainer ul:hover li.hasDropDown {
    opacity: 0.6;
  }
  .menuWrapper .navContainer ul:hover li.hasDropDown:hover {
    opacity: 1;
  }
}
@media (min-width: 769px) and (max-width: 1199px) {
  .menuWrapper .navContainer {
    width: 350px;
  }
  .blcontained {
    width: 100%;
    margin: 0 auto;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .menuWrapper .navContainer {
    left: 80px;
  }
}
@media (max-width: 768px) {
  .menuWrapper {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 99;
    visibility: hidden;
    transition: visibility 850ms ease-out;
  }
  .menuWrapper:before {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background: #000;
    transform: scaleX(0);
    transform-origin: center left;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: 250ms;
    display: none;
  }
  .menuWrapper:after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 96%;
    z-index: 3;
    bottom: 0;
    background: rgba(13, 67, 136, 0.96);
    transform: scaleX(0);
    transform-origin: center left;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: 0.1s;
  }
  .menuWrapper .menuInner {
    position: relative;
    z-index: 100;
    height: 100%;
  }
  .menuWrapper .menuInner .navContainer {
    height: 100%;
    overflow: auto;
    padding: 150px 0 60px;
    transform: translateX(-100%);
    transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: 0.4s;
  }
  .menuWrapper .menuInner .navContainer ul {
    padding: 0;
  }
  .menuWrapper .menuInner .navContainer ul li {
    display: block;
    font-size: 30px;
    line-height: 60px;
  }
  .menuWrapper .menuInner .navContainer ul li a {
    display: inline-block;
    color: #fff;
    padding: 0 30px;
  }
  .menuWrapper .menuInner .navContainer ul li .dropdown {
    display: none;
    padding-left: 15px;
  }
  .menuWrapper .menuInner .navContainer ul li .dropdown li {
    font-size: 16px;
    opacity: 0.8;
    line-height: 30px;
  }
  .menuWrapper .menuInner .navContainer ul li.active .dropdown {
    display: block;
  }
  .menuWrapper .menuInner .addressBox {
    padding: 0;
    opacity: 0;
    transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: 0.6s;
  }
  .menuWrapper .menuInner .addressBox .atext, .menuWrapper .menuInner .addressBox .rightBox {
    display: none;
  }
  .menuWrapper .menuInner .addressBox .follow {
    padding: 11px 30px;
  }
  .menuWrapper .menuInner .addressBox .follow h4 {
    float: left;
    margin: 0;
    width: 50%;
    font-family: proxima_novaregular;
    color: #fff;
    line-height: 28px;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  .menuWrapper .menuInner .addressBox .follow ul {
    padding: 0;
    margin: 0;
    width: 50%;
    float: right;
    text-align: right;
  }
  .menuWrapper .menuInner .addressBox .follow ul li {
    display: inline-block;
    font-size: 18px;
    margin: 0 10px;
    line-height: 28px;
  }
  .menuWrapper .menuInner .addressBox .follow ul li a {
    color: #fff;
    display: block;
  }
  .nav-active .menuWrapper {
    opacity: 1;
    visibility: visible;
    transition-delay: 0s;
  }
  .nav-active .menuWrapper:before {
    transform: scaleX(1);
    transition-delay: 0.2s;
  }
  .nav-active .menuWrapper:after {
    transform: scaleX(1);
    transition-delay: 0.3s;
  }
  .nav-active .menuWrapper .addressBox, .nav-active .menuWrapper .navContainer {
    opacity: 1;
    transform: translateX(0);
  }
}
.navbar .menuBtn {
  float: none !important;
  margin: 0 0 0 10px;
  display: none;
}

@media (max-width: 480px) {
  .navbar .menuBtn {
    margin: 0 10px;
  }
}
@media (max-width: 360px) {
  .navbar .menuBtn {
    margin: 0 5px;
  }
}
.navbar .menuBtn a {
  position: relative;
  width: 33px;
  height: 26px;
  cursor: pointer;
  display: block;
  z-index: 999999999999;
  transition: all 20ms cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: 0.1s;
}

.navbar .menuBtn span {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 33px;
  height: 3px;
  z-index: 1;
  background: #fff;
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.navbar .menuBtn.new_btn span {
  background-color: #FFF;
}

.navbar .menuBtn span:last-child {
  top: 22px;
}

.navbar .menuBtn span.cross {
  top: 10px;
  left: 7px;
  z-index: 2;
  background: 0 0;
}

.navbar .menuBtn span.cross:after, .navbar .menuBtn span.cross:before {
  display: block;
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 3px;
  background: #fff;
  transition: all 350ms cubic-bezier(0.4, 0, 0.2, 1);
}

.navbar .menuBtn.new_btn span.cross:after, .navbar .menuBtn.new_btn span.cross:before {
  background-color: #FFF;
}

.navbar .menuBtn:hover span.cross {
  left: 0;
}

.navbar .menuBtn .is-active span:first-child {
  opacity: 0;
}

.navbar .menuBtn .is-active span:last-child {
  opacity: 0;
}

.navbar .menuBtn .is-active span.cross {
  height: 26px;
  top: 0;
  left: 0;
}

.navbar .menuBtn .is-active span.cross:before {
  transform: rotate(-45deg);
}

.navbar .menuBtn .is-active span.cross:after {
  transform: rotate(45deg);
}

.navbar.sticky .menuBtn span, .navbar.white .menuBtn span {
  background: #012a5e;
}

.navbar.sticky .menuBtn span.cross, .navbar.white .menuBtn span.cross {
  background: 0 0;
}

.navbar.sticky .menuBtn span.cross:after, .navbar.sticky .menuBtn span.cross:before, .navbar.white .menuBtn span.cross:after, .navbar.white .menuBtn span.cross:before {
  background: #012a5e;
}

.navbar.sticky .menuBtn a.is-active span, .navbar.white .menuBtn a.is-active span {
  background: #fff;
}

.navbar.sticky .menuBtn a.is-active span.cross, .navbar.white .menuBtn a.is-active span.cross {
  background: 0 0;
}

.navbar.sticky .menuBtn a.is-active span.cross:after, .navbar.sticky .menuBtn a.is-active span.cross:before, .navbar.white .menuBtn a.is-active span.cross:after, .navbar.white .menuBtn a.is-active span.cross:before {
  background: #fff;
}`, "",{"version":3,"sources":["webpack://./src/styles/tnc.scss"],"names":[],"mappings":"AAAA;EAAW,uDAAA;AAEX;;AADA;EAAsB,2BAAA;AAKtB;;AAJA;EAAyB,WAAA;EAAY,gBAAA;EAAiB,eAAA;AAUtD;;AATA;EAAa,eAAA;AAab;;AAZA;EAAe,eAAA;AAgBf;;AAdE;EACE,UAAA;EACA,SAAA;AAiBJ;AAfI;EACE,gBAAA;AAiBN;;AAZA;EAAQ,YAAA;EAAa,cAAA;AAiBrB;;AAhBA;EAAM,yBAAA;AAoBN;;AAnBA;EAAO,yBAAA;AAuBP;;AArBE;EACE,mBAAA;EAAoB,UAAA;AAyBxB;AAvBI;EACE,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,mBAAA;AAyBN;AAvBM;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAyBR;AAtBM;EACE,gBAAA;AAwBR;AArBM;EACE,gBAAA;EACA,mBAAA;AAuBR;AAlBQ;EAEE,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAoBV;AAjBY;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AAmBd;AAdQ;EACE,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,QAAA;AAgBV;AAVI;EACE,gCAAA;EACA,uBAAA;EACA,kBAAA;EACA,OAAA;EACA,4BAAA;EACA,eAAA;EACA,SAAA;AAYN;AANI;EAAU,aAAA;AASd;;AADE;EACE,2BAAA;AAIJ;AAFE;EACE,eAAA;EACA,gBAAA;EACA,MAAA;AAIJ;;AAAA;EACE;IAAQ,WAAA;EAIR;EAHA;IAAS,+BAAA;EAMT;EALA;IAA6B,0BAAA;EAQ7B;EAPA;IAAgC,6BAAA;EAUhC;EATA;IAAgC,UAAA;EAYhC;AACF;AAVA;EAAQ,uBAAA;EAAwB,UAAA;EAAW,aAAA;EAAa,eAAA;EAAgB,MAAA;EAAO,OAAA;EAAQ,QAAA;EAAS,eAAA;EAAmJ,iEAAA;AAuBnP;;AAtBA;EAAsB,aAAA;EAAc,kBAAA;EAAmB,eAAA;AA4BvD;;AA3BA;EAAmC,6DAAA;EAAiE,qBAAA;EAAsB,YAAA;EAAa,YAAA;AAkCvI;;AAjCA;EAAkB,qBAAA;AAqClB;;AApCA;EAAe,MAAA;AAwCf;;AAvCA;EAA+C,6DAAA;EAA2D,qBAAA;EAAsB,YAAA;EAAa,YAAA;AA8C7I;;AA7CA;EAA8B,gBAAA;EAAkE,4CAAA;AAmDhG;;AAlDA;EAAa,kBAAA;EAAmB,YAAA;AAuDhC;;AAtDA;EAAgC,gBAAA;AA0DhC;;AAzDA;EAAsB,qBAAA;EAAsB,kBAAA;AA8D5C;;AA7DA;EAAwB,eAAA;EAAgB,WAAA;EAAY,cAAA;EAAe,kBAAA;AAoEnE;;AAnEA;EAA6E,cAAA;AAuE7E;;AAtEA;EAA2B,mBAAA;EAAoB,kBAAA;EAAmB,mBAAA;EAAoB,yBAAA;EAA0B,yBAAA;EAA0B,gBAAA;EAAiB,qIAAA;EAA+H,kBAAA;AAiF1R;;AAhFA;EAAgC,uBAAA;EAAwB,kBAAA;EAAmB,mBAAA;EAAoB,sBAAA;EAAuB,yBAAA;EAA0B,gBAAA;EAAiB,qIAAA;AA0FjK;;AAzFA;EAAiC,mBAAA;AA6FjC;;AA5FA;EAAmF,WAAA;EAAW,mBAAA;EAAoB,qBAAA;EAAsB,kCAAA;AAmGxI;;AAlGA;EAA6F,qBAAA;AAsG7F;;AArGA;EAAO,qBAAA;EAAsB,yBAAA;EAA0B,qBAAA;EAAsB,YAAA;AA4G7E;;AA3GA;EAAM,wBAAA;EAAyB,gCAAA;EAAiC,mBAAA;EAAoB,gCAAA;AAkHpF;;AAjHA;EAAO,0BAAA;EAA2B,iCAAA;EAAkC,mBAAA;EAAoB,gCAAA;AAwHxF;;AAvHA;EAA6F,qBAAA;AA2H7F;;AA1HA;EAAsC,kBAAA;EAAmB,SAAA;EAAU,OAAA;EAAQ,UAAA;EAAW,YAAA;EAAa,gBAAA;EAAiB,gBAAA;EAAiB,UAAA;EAAW,kBAAA;EAAyH,4BAAA;EAAwI,oDAAA;EAAuK,0DAAA;EAAsD,iDAAA;EAAkD,mBAAA;AAkJhqB;;AAjJA;EAA4C,UAAA;EAAW,mBAAA;EAA8G,wBAAA;AA0JrK;;AAzJA;EAA2C,yBAAA;AA6J3C;;AA5JA;EAAyC,cAAA;EAAe,eAAA;EAAgB,eAAA;EAAgB,iBAAA;EAAkB,gBAAA;AAoK1G;;AAnKA;EAA2C,4BAAA;EAA6B,WAAA;EAAY,aAAA;EAAc,2CAAA;EAA4C,eAAA;AA2K9I;;AA1KA;EAAqD,4BAAA;EAA6B,6BAAA;AA+KlF;;AA9KA;EAAoD,mBAAA;EAAoB,+BAAA;EAAgC,gCAAA;AAoLxG;;AAnLA;EAAsD,mBAAA;AAuLtD;;AAtLA;EAAmH,WAAA;AA0LnH;;AAzLA;EACE;IAEE,sCAAA;EA4LF;EA1LA;IAEE,sCAAA;EA4LF;EA1LA;IAEE,yCAAA;EA4LF;AACF;AA1LA;EAA4D,kBAAA;EAAmB,MAAA;EAAO,UAAA;EAAW,UAAA;EAAW,YAAA;EAAa,gBAAA;EAAiB,UAAA;EAAW,kBAAA;EAAyH,4BAAA;EAAwI,oDAAA;EAAuK,0DAAA;EAAsD,gBAAA;EAAiB,iDAAA;EAA+C,mBAAA;AAiNnrB;;AAhNA;EAAkE,UAAA;EAAW,mBAAA;EAA8G,wBAAA;AAyN3L;;AAxNA;EAA6B,kBAAA;EAAmB,YAAA;EAAa,eAAA;EAAgB,yBAAA;AA+N7E;;AA9NA;EAA+C,mBAAA;AAkO/C;;AAjOA;EAAiD,WAAA;AAqOjD;;AApOA;EAAyD,kBAAA;AAwOzD;;AAvOA;EAAuE,WAAA;AA2OvE;;AA1OA;EAA6E,WAAA;AA8O7E;;AA7OA;EAA2H,mBAAA;AAiP3H;;AAhPA;EAA+H,WAAA;AAoP/H;;AAnPA;EAA2K,WAAA;AAuP3K;;AAtPA;EAAuL,WAAA;AA0PvL;;AAzPA;EAAc,iBAAA;AA6Pd;;AA5PA;EAAa,kBAAA;EAAmB,UAAA;EAAW,WAAA;EAAY,cAAA;AAmQvD;;AAlQA;EAAe,cAAA;EAAe,YAAA;EAAa,YAAA;EAAa,UAAA;EAAW,6DAAA;EAA2D,qBAAA;EAAsB,gBAAA;AA4QpJ;;AA3QA;EAAkB,aAAA;EAAc,kBAAA;AAgRhC;;AA/QA;EAAqB,kBAAA;EAAmB,YAAA;AAoRxC;;AAnRA;EAAwB,qBAAA;AAuRxB;;AAtRA;EAA0B,WAAA;EAAY,yBAAA;EAA0B,kBAAA;AA4RhE;;AA3RA;EAAuC,kBAAA;EAAmB,yBAAA;EAA0B,mBAAA;AAiSpF;;AAhSA;EAAqI,yBAAA;AAwSrI;;AAvSA;EAAiB,YAAA;EAAa,sBAAA;AA4S9B;;AA3SA;EAAmB,aAAA;AA+SnB;;AA7SA;EACE;IAAmB,cAAA;EAiTnB;EAhTA;IAAyB,qBAAA;EAmTzB;EAlTA;IAAiC,qBAAA;EAqTjC;EApTA;IAA4B,qBAAA;EAuT5B;EAtTA;IAA8B,kBAAA;IAAmB,QAAA;EA0TjD;AACF;AAxTA,eAAA;AAEA;EACE,uDAAA;AAyTF;;AAtTA;EAAc,eAAA;AA0Td;;AAzTA;EAA+B,mBAAA;AA6T/B;;AA5TA;EAAqC,mBAAA;EAAoB,yBAAA;AAiUzD;;AAhUA;EAAuD,gBAAA;AAoUvD;;AAnUA;EAAuC,WAAA;AAuUvC;;AArUA;EAAY,gBAAA;AAyUZ;;AAxUA;EAAe,mBAAA;EAAoB,gBAAA;EAAiB,WAAA;AA8UpD;;AA7UA;EAAkB,cAAA;EAAe,eAAA;AAkVjC;;AAjVA;EAAoB,WAAA;AAqVpB;;AApVA;EAAe,aAAA;AAwVf;;AAtVA;EAAkB,eAAA;AA0VlB;;AAzVA;EAAoB,gBAAA;EAAiB,cAAA;EAAe,2BAAA;AA+VpD;;AA9VA;EAAwB,qBAAA;EAAsB,kBAAA;EAAmB,WAAA;AAoWjE;;AAnWA;EAAqC,eAAA;AAuWrC;;AAtWA;EAA0B,WAAA;AA0W1B;;AAxWA;EAAwB,YAAA;AA4WxB;;AA1WA;EAAS,6DAAA;EAAgD,WAAA;EAAY,YAAA;EAAa,qBAAA;EAAsB,kBAAA;AAkXxG;;AAjXA;EAAgB,kBAAA;EAAkB,qBAAA;EAAsB,mBAAA;AAuXxD;;AAtXA;EAAgB,aAAA;AA0XhB;;AAxXA,mBAAA;AAEA;EACE;IAA4B,aAAA;EA2X5B;AACF;AAzXE;EACE;IAAa,eAAA;EA4Xf;EA3XE;IAAiB,aAAA;EA8XnB;EA7XE;IAAc,aAAA;EAgYhB;EA/XE;IAAiB,kBAAA;IAAmB,eAAA;EAmYtC;EAlYE;IAAqC,WAAA;IAAY,kBAAA;EAsYnD;EArYE;IAAsC,iBAAA;IAAkB,kBAAA;EAyY1D;EAxYE;IAAe,gBAAA;IAAiB,mBAAA;EA4YlC;EA3YE;IAAkB,kBAAA;EA8YpB;EA7YE;IAAqB,qBAAA;IAAsB,kBAAA;IAAmB,kBAAA;EAkZhE;EAjZE;IAAuB,WAAA;IAAY,kBAAA;EAqZrC;EApZE;IAAa,kBAAA;IAAmB,gBAAA;EAwZlC;EAvZE;IAAmB,qBAAA;IAAsB,kBAAA;IAAmB,iBAAA;IAAkB,WAAA;EA6ZhF;EA5ZE;IAAmB,aAAA;EA+ZrB;EA9ZE;IAA2B,cAAA;EAia7B;EAhaE;IAAW,YAAA;IAAa,2BAAA;IAA4B,aAAA;IAAc,kBAAA;EAsapE;EAraE;IAAsB,kBAAA;EAwaxB;EAvaE;IAAyB,eAAA;EA0a3B;EAzaE;IAAuE,aAAA;EA4azE;EA3aE;IAA0B,UAAA;IAAW,kBAAA;EA+avC;EA9aE;IAAgB,aAAA;EAiblB;EAhbE;IAA8B,cAAA;IAAe,iBAAA;EAob/C;EAnbE;IAAqC,aAAA;EAsbvC;EArbE;IAAa,gBAAA;EAwbf;EAvbE;IAAgB,qBAAA;EA0blB;EAzbE;IAAiE,YAAA;IAAa,YAAA;IAAa,wBAAA;EA8b7F;AACF;AA5bA,qBAAA;AAEA;EACE;IAAa,eAAA;IAAgB,MAAA;IAAO,OAAA;IAAQ,QAAA;IAAS,SAAA;IAAU,UAAA;IAAW,UAAA;IAAW,kBAAA;IAAmB,kBAAA;IAAmB,kBAAA;EAuc3H;EArcA;IAAqB,WAAA;IAAY,eAAA;IAAgB,MAAA;IAAO,QAAA;IAAS,UAAA;IAAW,WAAA;IAAY,YAAA;IAAa,iCAAA;IAA6J,uDAAA;EAkdlQ;AACF;AAjdA;EACE;IAAqB,WAAA;EAodrB;EAndA;IAAmC,eAAA;EAsdnC;EArdA;IAAiB,YAAA;EAwdjB;AACF;AAvdA;EACE;IAAsB,UAAA;IAAW,mBAAA;EA2djC;EA1dA;IAAiC,UAAA;IAAW,mBAAA;IAA2F,6BAAA;EAievI;EAheA;IAA2B,kBAAA;IAAmB,QAAA;IAAS,SAAA;IAAU,YAAA;IAAa,iBAAA;IAAqH,2BAAA;EA2enM;EA1eA;IAA8B,SAAA;EA6e9B;EA5eA;IAAiC,kBAAA;IAAmB,UAAA;IAAW,cAAA;IAAe,gBAAA;IAAiB,eAAA;IAAgB,iBAAA;IAAyI,qDAAA;EAufxP;EAtfA;IAAmC,qBAAA;IAAsB,WAAA;IAA+H,mDAAA;EA6fxL;AACF;AA5fA;EACE;IAAmC,gBAAA;EA+fnC;AACF;AA9fA;EACE;IAAoD,WAAA;IAAY,kBAAA;IAAmB,SAAA;IAAU,WAAA;IAAY,QAAA;IAAS,WAAA;IAAY,WAAA;IAAY,gBAAA;IAAoI,mDAAA;EA2gB9Q;AACF;AA1gBA;EACE;IAAoD,SAAA;IAAU,WAAA;EA8gB9D;AACF;AA7gBA;EACE;IAA2C,kBAAA;IAAmB,SAAA;IAAU,UAAA;IAAW,eAAA;IAAgB,kBAAA;IAAwG,oCAAA;IAA8F,sBAAA;EA0hBzS;EAzhBA;IAAwD,UAAA;EA4hBxD;EA3hBA;IAAyD,SAAA;IAAU,SAAA;EA+hBnE;EA9hBA;IAA8C,gBAAA;IAAiB,eAAA;IAAgB,UAAA;IAAW,gBAAA;IAAiB,gBAAA;IAAiB,iBAAA;IAAkB,mBAAA;IAAoB,oBAAA;IAAwH,2BAAA;IAA+O,mGAAA;EA+iBzgB;EA9iBA;IAAqD,aAAA;EAijBrD;EAhjBA;IAAsH,uBAAA;EAqjBtH;EApjBA;IAAsH,uBAAA;EAyjBtH;EAxjBA;IAAoH,sBAAA;EA6jBpH;EA5jBA;IAAsH,uBAAA;EAikBtH;EAhkBA;IAAsH,uBAAA;EAqkBtH;EApkBA;IAAsH,uBAAA;EAykBtH;EAxkBA;IAAsH,uBAAA;EA6kBtH;EA5kBA;IAAsH,uBAAA;EAilBtH;EAhlBA;IAAsH,uBAAA;EAqlBtH;EAplBA;IAAqH,sBAAA;EAylBrH;EAxlBA;IAAuH,uBAAA;EA6lBvH;EA5lBA;IAAuH,uBAAA;EAimBvH;EAhmBA;IAAgD,eAAA;EAmmBhD;AACF;AAlmBA;EACE;IAA8C,eAAA;EAqmB9C;AACF;AApmBA;EACE;IAA2C,SAAA;EAumB3C;AACF;AAtmBA;EACE;IAA0D,WAAA;EAymB1D;EAxmBA;IAAyC,WAAA;EA2mBzC;EA1mBA;IAAiD,mBAAA;IAA6E,sBAAA;EAgnB9H;EA/mBA;IAAoD,UAAA;IAAqG,wBAAA;EAsnBzJ;EArnBA;IAGI,uBAAA;EAunBJ;EArnBA;IAGI,uBAAA;EAunBJ;EArnBA;IAGI,uBAAA;EAunBJ;EArnBA;IAGI,uBAAA;EAunBJ;EArnBA;IAGI,sBAAA;EAunBJ;EArnBA;IAGI,uBAAA;EAunBJ;EArnBA;IAGI,uBAAA;EAunBJ;EArnBA;IAGI,uBAAA;EAunBJ;EArnBA;IAGI,uBAAA;EAunBJ;EArnBA;IAGI,sBAAA;EAunBJ;EArnBA;IAGI,uBAAA;EAunBJ;EArnBA;IAGI,uBAAA;EAunBJ;EArnBA;IAA4D,YAAA;EAwnB5D;EAvnBA;IAAkE,UAAA;EA0nBlE;AACF;AAznBA;EACE;IAAiC,eAAA;IAAgB,iBAAA;EA6nBjD;AACF;AA5nBA;EACE;IAAmD,YAAA;EA+nBnD;EA9nBA;IAAyD,UAAA;EAioBzD;AACF;AAhoBA;EACE;IAA2B,YAAA;EAmoB3B;EAloBA;IAAa,WAAA;IAAY,cAAA;EAsoBzB;AACF;AAroBA;EACE;IAA2B,UAAA;EAwoB3B;AACF;AAvoBA;EACE;IAAc,eAAA;IAAgB,MAAA;IAAO,OAAA;IAAQ,SAAA;IAAU,WAAA;IAAY,WAAA;IAAY,kBAAA;IAA0G,qCAAA;EAmpBzL;EAlpBA;IAAqB,kBAAA;IAAmB,WAAA;IAAY,MAAA;IAAO,OAAA;IAAQ,QAAA;IAAS,SAAA;IAAU,UAAA;IAAW,gBAAA;IAA+F,oBAAA;IAA8H,6BAAA;IAAmQ,uDAAA;IAAwK,uBAAA;IAAwB,aAAA;EA2qBjwB;EA1qBA;IAAmB,kBAAA;IAAmB,WAAA;IAAY,MAAA;IAAO,OAAA;IAAQ,UAAA;IAAW,UAAA;IAAW,SAAA;IAAU,mCAAA;IAAkH,oBAAA;IAA8H,6BAAA;IAAmQ,uDAAA;IAAsK,sBAAA;EAksB1vB;EAjsBA;IAAyB,kBAAA;IAAmB,YAAA;IAAa,YAAA;EAssBzD;EArsBA;IAAsC,YAAA;IAAa,cAAA;IAAe,qBAAA;IAA4H,4BAAA;IAAwJ,uDAAA;IAAiH,sBAAA;EAotBvc;EAntBA;IAAyC,UAAA;EAstBzC;EArtBA;IAA4C,cAAA;IAAe,eAAA;IAAgB,iBAAA;EA0tB3E;EAztBA;IAA8C,qBAAA;IAAsB,WAAA;IAAY,eAAA;EA8tBhF;EA7tBA;IAAsD,aAAA;IAAc,kBAAA;EAiuBpE;EAhuBA;IAAyD,eAAA;IAAgB,YAAA;IAAa,iBAAA;EAquBtF;EApuBA;IAA6D,cAAA;EAuuB7D;EAtuBA;IAAoC,UAAA;IAAW,UAAA;IAAkI,qDAAA;IAA+G,sBAAA;EAgvBhS;EA/uBA;IAAyF,aAAA;EAkvBzF;EAjvBA;IAA4C,kBAAA;EAovB5C;EAnvBA;IAA+C,WAAA;IAAY,SAAA;IAAU,UAAA;IAAW,gCAAA;IAAiC,WAAA;IAAY,iBAAA;IAAkB,mBAAA;IAAoB,yBAAA;EA6vBnK;EA5vBA;IAA+C,UAAA;IAAW,SAAA;IAAU,UAAA;IAAW,YAAA;IAAa,iBAAA;EAmwB5F;EAlwBA;IAAkD,qBAAA;IAAsB,eAAA;IAAgB,cAAA;IAAe,iBAAA;EAwwBvG;EAvwBA;IAAoD,WAAA;IAAY,cAAA;EA2wBhE;EA1wBA;IAAyB,UAAA;IAAW,mBAAA;IAAoB,oBAAA;EA+wBxD;EA9wBA;IAAuF,oBAAA;IAAqB,sBAAA;EAoxB5G;EAnxBA;IAAqF,oBAAA;IAAqB,sBAAA;EAyxB1G;EAxxBA;IAA4E,UAAA;IAAqG,wBAAA;EA+xBjL;AACF;AA7xBA;EAAiB,sBAAA;EAAuB,kBAAA;EAAmB,aAAA;AAkyB3D;;AAjyBA;EACE;IAAkB,cAAA;EAqyBlB;AACF;AAnyBA;EACE;IACI,aAAA;EAqyBJ;AACF;AAnyBA;EAAmB,kBAAA;EAAmB,WAAA;EAAY,YAAA;EAAa,eAAA;EAAgB,cAAA;EAAe,qBAAA;EAAqI,iDAAA;EAA2G,sBAAA;AAizB9U;;AAhzBA;EAAsB,kBAAA;EAAmB,MAAA;EAAO,OAAA;EAAQ,cAAA;EAAe,WAAA;EAAY,WAAA;EAAY,UAAA;EAAW,gBAAA;EAAkI,kDAAA;AA8zB5O;;AA7zBA;EAA8B,sBAAA;AAi0B9B;;AAh0BA;EAAiC,SAAA;AAo0BjC;;AAn0BA;EAA4B,SAAA;EAAU,SAAA;EAAU,UAAA;EAAW,eAAA;AA00B3D;;AAz0BA;EAAsE,cAAA;EAAe,WAAA;EAAY,kBAAA;EAAmB,QAAA;EAAS,OAAA;EAAQ,WAAA;EAAY,WAAA;EAAY,gBAAA;EAAkI,kDAAA;AAu1B/R;;AAt1BA;EAAsF,sBAAA;AA01BtF;;AAz1BA;EAAkC,OAAA;AA61BlC;;AA51BA;EAA6C,UAAA;AAg2B7C;;AA/1BA;EAA4C,UAAA;AAm2B5C;;AAl2BA;EAAuC,YAAA;EAAa,MAAA;EAAO,OAAA;AAw2B3D;;AAv2BA;EAA2I,yBAAA;AA82B3I;;AA72BA;EAAgJ,wBAAA;AAo3BhJ;;AAn3BA;EAA0D,mBAAA;AAu3B1D;;AAt3BA;EAAsE,eAAA;AA03BtE;;AAz3BA;EAAoK,mBAAA;AA63BpK;;AA53BA;EAAkF,gBAAA;AAg4BlF;;AA/3BA;EAA8F,eAAA;AAm4B9F;;AAl4BA;EAAqN,gBAAA;AAs4BrN","sourcesContent":[".nvsbanner{background: linear-gradient(to right, #006bc0 , #691dc0);}\r\n.nvs_banner_container{padding: 130px 0 80px 100px;;}\r\n.nvs_banner_container h1{color: #FFF;font-weight: 900;font-size: 36px;}\r\n.bigspacing {padding: 80px 0;}\r\n.smallspacing {padding: 40px 0;}\r\n.nvfooter{\r\n  ul{\r\n    padding: 0;\r\n    margin: 0;\r\n\r\n    li{\r\n      list-style: none;\r\n    }\r\n  }\r\n} \r\n\r\n.wid900{width: 900px;margin: 0 auto;}\r\n.ttbg{background-color: #faf9fc;}\r\n.ppbg {background-color: #f5f4fa;}\r\n.tncbox{\r\n  ol{\r\n    counter-reset: item;padding: 0;\r\n    \r\n    li{\r\n      display: block;\r\n      position: relative;\r\n      font-family: 'Gilroy Medium';\r\n      margin-bottom: 40px;\r\n\r\n      h3{\r\n        font-size: 24px;\r\n        margin-left: 30px;\r\n        margin-bottom: 15px;\r\n        font-weight: 700;\r\n      }\r\n\r\n      h4{\r\n        font-weight: 500;\r\n      }\r\n\r\n      h5{\r\n        font-weight: 500;\r\n        margin-bottom: 15px;\r\n      }\r\n\r\n      ol{\r\n\r\n        li{\r\n          -webkit-column-break-inside: avoid;\r\n          page-break-inside: avoid;\r\n          break-inside: avoid;\r\n          text-align: justify;\r\n          font-family: 'Gilroy Light';\r\n          margin-left: 50px;\r\n          font-size: 16px;\r\n          margin-bottom: 15px;\r\n\r\n          ul{\r\n            li{\r\n              list-style: disc;\r\n              margin-left: 20px;\r\n              margin-top: 10px;\r\n            }\r\n          } \r\n        } \r\n\r\n        li:before{\r\n          margin-left: -50px;\r\n          font-family: 'Gilroy Light';\r\n          font-size: 16px;\r\n          top:3px;\r\n        }\r\n      } \r\n\r\n    }\r\n\r\n    li:before {\r\n      content: counters(item, \".\") \".\";\r\n      counter-increment: item;\r\n      position: absolute;\r\n      left: 0;\r\n      font-family: 'Gilroy Medium';\r\n      font-size: 24px;\r\n      top: -2px;\r\n    }\r\n  }\r\n\r\n  ul{\r\n\r\n    li:before{display: none;}\r\n\r\n  } \r\n}\r\n\r\n.tncbox ol \r\n\r\n.termsAndCondition__list{\r\n  li{\r\n    font-family: 'Gilroy Light';\r\n  }\r\n  li:before{\r\n    font-size: 24px;\r\n    line-height: 1.2;\r\n    top: 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-width:768px){\r\n  .wid900{width: 100%;}\r\n  .tncbox {padding-bottom:40px !important;}\r\n  .termsAndCondition__list li {padding-left: 0 !important; }\r\n  .termsAndCondition__list li h3 {padding-left: 40px !important; }\r\n  .termsAndCondition__list ol li {padding: 0;}\r\n}\r\n\r\n.navbar{background: transparent;padding: 0;height:100px;position: fixed;top: 0;left: 0;right: 0;z-index: 999999;-webkit-transition: background 150ms cubic-bezier(.645,.045,.355,1);-o-transition: background 150ms cubic-bezier(.645,.045,.355,1);transition: background 150ms cubic-bezier(.645,.045,.355,1);}\r\n.navbar .navbar-brand{height: 100px;line-height: 100px;padding: 20px 0;}\r\n.navbar .nl_logo,.hidebig .nl_logo{background: url(../Image/novus_loyalty_logo_white.png) no-repeat;display: inline-block;width: 144px;height: 60px;}\r\n.hidebig .nl_logo{margin: 10px 0 0 10px;}\r\n.navbar.sticky{top:0;}\r\n.navbar.sticky .nl_logo,.navbar.white .nl_logo{background: url(../Image/novus_loyalty_logo.png) no-repeat;display: inline-block;width: 144px;height: 60px;}\r\n.navbar.sticky, .navbar.white{background: #fff;-webkit-box-shadow: 0 0 10px 2px rgb(0 0 0 / 6%);box-shadow: 0 0 10px 2px rgb(0 0 0 / 6%);}\r\n.navbar-menu{position: relative;float: right;}\r\n.navbar-menu .navigation_box ul{margin-bottom: 0;}\r\n.navigation_box ul li{display: inline-block;position: relative;}\r\n.navigation_box ul li a{padding: 0 15px;color: #FFF;display: block;position: relative;}\r\n.navbar.sticky .navigation_box ul li a,.navbar.white .navigation_box ul li a{color:#0a6ebe}\r\n.navigation_box a.bookdemo{background: #ff9900;padding: 10px 20px;border-radius: 30px;border: 1px solid #ff9900;text-transform: uppercase;font-weight: 500;transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;margin-right:15px;}\r\n.navigation_box a.tryforfreebtn{background: transparent;padding: 10px 20px;border-radius: 30px;border: 1px solid #FFF;text-transform: uppercase;font-weight: 500;transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;}\r\n.navigation_box a.bookdemo:hover{background: #ec8f04;}\r\n.navbar.sticky .navigation_box a.bookdemo,.navbar.white .navigation_box a.bookdemo{color:#FFF;background: #0a6ebe;border-color: #0a6ebe;animation: fade-shadow 6s infinite;}\r\n.navbar.sticky .navigation_box a.tryforfreebtn,.navbar.white .navigation_box a.tryforfreebtn{border-color: #0a6ebe;}\r\n.arrow{border: solid #fbfaff;border-width: 0 1px 1px 0;display: inline-block;padding: 3px;}\r\n.down{transform: rotate(45deg);-webkit-transform: rotate(45deg);margin: 0 0 3px 3px;transition: all 0.5s ease-in-out;}\r\n.right{transform: rotate(-455deg);-webkit-transform: rotate(-45deg);margin: 0 0 3px 3px;transition: all 0.5s ease-in-out;}\r\n.navbar.sticky .navigation_box ul li a i.arrow,.navbar.white .navigation_box ul li a i.arrow{border-color: #0a6ebe;}\r\n.navigation_box ul li .customDropDown{position: absolute;top: 100%;left: 0;padding: 0;width: 240px;text-align: left;margin-top: 40px;opacity: 0;visibility: hidden;-webkit-transform: translateY(100px);-ms-transform: translateY(100px);-o-transform: translateY(100px);transform: translateY(100px);-webkit-transition: all 650ms cubic-bezier(.76,0,.11,1);-o-transition: all 650ms cubic-bezier(.76,0,.11,1);transition: all 650ms cubic-bezier(.76,0,.11,1);-webkit-transition-timing-function: cubic-bezier(.76,0,.31,1);-o-transition-timing-function: cubic-bezier(.76,0,.31,1);transition-timing-function: cubic-bezier(.76,0,.31,1);box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;border-radius: 10px;}\r\n.navigation_box ul li:hover .customDropDown{opacity: 1;visibility: visible;-webkit-transform: translateY(0);-ms-transform: translateY(0);-o-transform: translateY(0);transform: translateY(0);}\r\n.navigation_box ul li:hover a i.arrow.down{transform: rotate(225deg);}\r\n.navigation_box ul li .customDropDown li{display: block;font-size: 13px;padding: 0 15px;line-height: 20px;background: #FFF;}\r\n.navigation_box ul li .customDropDown li a{font-family: 'Gilroy Medium';color: #000;padding: 15px;border-bottom: 1px solid rgba(0, 0, 0, 0.5);font-size: 14px;}\r\n.navigation_box ul li .customDropDown li:first-child{border-top-left-radius: 10px;border-top-right-radius: 10px;}\r\n.navigation_box ul li .customDropDown li:last-child{border-bottom: none;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;}\r\n.navigation_box ul li .customDropDown li:last-child a{border-bottom: none;}\r\n.navbar.sticky .navigation_box ul li .customDropDown li a,.navbar.white .navigation_box ul li .customDropDown li a{color:#000;}\r\n@keyframes fade-shadow {\r\n  0% {\r\n    -webkit-box-shadow: 0 0 0 0 rgb(244 244 244);\r\n    box-shadow: 0 0 0 0 rgb(244 244 244);\r\n  }\r\n  10%{\r\n    -webkit-box-shadow: 0 0 0 0 rgb(244 244 244);\r\n    box-shadow: 0 0 0 0 rgb(244 244 244);\r\n  }\r\n  100% {\r\n    -webkit-box-shadow: 0 0 0 10px rgb(244 244 244);\r\n    box-shadow: 0 0 0 10px rgb(244 244 244);\r\n  }\r\n}\r\n.navigation_box ul li .customDropDown li .customDropDownSub{position: absolute;top: 0;left: 100%;padding: 0;width: 240px;text-align: left;opacity: 0;visibility: hidden;-webkit-transform: translateY(100px);-ms-transform: translateY(100px);-o-transform: translateY(100px);transform: translateY(100px);-webkit-transition: all 650ms cubic-bezier(.76,0,.11,1);-o-transition: all 650ms cubic-bezier(.76,0,.11,1);transition: all 650ms cubic-bezier(.76,0,.11,1);-webkit-transition-timing-function: cubic-bezier(.76,0,.31,1);-o-transition-timing-function: cubic-bezier(.76,0,.31,1);transition-timing-function: cubic-bezier(.76,0,.31,1);margin-left: 3px;box-shadow: rgb(0 0 0 / 15%) 2.4px 2.4px 3.2px;border-radius: 10px;}\r\n.navigation_box ul li .customDropDown li:hover .customDropDownSub{opacity: 1;visibility: visible;-webkit-transform: translateY(0);-ms-transform: translateY(0);-o-transform: translateY(0);transform: translateY(0);}\r\n.customDropDown li a i.arrow{border-color: #000;float: right;margin-top: 7px;border-width: 0 2px 2px 0;}\r\n.navigation_box ul li .customDropDown li:hover{background: #006bc0;}\r\n.navigation_box ul li .customDropDown li:hover a{color: #FFF;}\r\n.navigation_box ul li .customDropDown li:hover a i.arrow{border-color: #FFF;}\r\n.navigation_box ul li .customDropDown li:hover .customDropDownSub li a{color: #000;}\r\n.navigation_box ul li .customDropDown li:hover .customDropDownSub li:hover a{color: #fff;}\r\n.navbar.sticky .navigation_box ul li .customDropDown li:hover,.navbar.white .navigation_box ul li .customDropDown li:hover{background: #006bc0;}\r\n.navbar.sticky .navigation_box ul li .customDropDown li:hover a,.navbar.white .navigation_box ul li .customDropDown li:hover a{color: #FFF;}\r\n.navbar.sticky .navigation_box ul li .customDropDown li:hover .customDropDownSub li a,.navbar.white .navigation_box ul li .customDropDown li:hover .customDropDownSub li a{color: #000;}\r\n.navbar.sticky .navigation_box ul li .customDropDown li:hover .customDropDownSub li:hover a,.navbar.white .navigation_box ul li .customDropDown li:hover .customDropDownSub li:hover a{color: #fff;}\r\n.header_space{margin-top: 100px;}\r\n.header_logo{position: relative;z-index: 1;float: left;padding: 4px 0;}\r\n.header_logo a{display: block;width: 150px;height: 80px;outline: 0;background: url(../Image/novus_loyalty_logo.png) no-repeat;background-size: 100%;margin-top: 15px;}\r\n.navigation_links{height: 100px;line-height: 100px;}\r\n.navigation_links ul{margin-left: 100px;float: right;}\r\n.navigation_links ul li{display: inline-block;}\r\n.navigation_links ul li a{color: #000;text-transform: uppercase;padding: 15px 15px;}\r\n.navigation_links ul li a.client_login{padding: 10px 30px;border: 1px solid #006bc0;border-radius: 30px;}\r\n.navigation{-webkit-transition: all 0.5s ease;-moz-transition: position 10s;-ms-transition: position 10s;-o-transition: position 10s;transition: all 0.5s ease;}\r\n.navigation_logo{width: 100px;margin: 15px 15px 10px;}\r\ndiv.bookdemomobbox{display: none;}\r\n\r\n@media only screen and (max-width:768px){\r\n  div.bookdemomobbox{display: block;}\r\n  div.bookdemomobbox ul li{display: inline-block;}\r\n  div.bookdemomobbox ul li.menuBtn{display: inline-block;}\r\n  div.bookdemomobbox .menuBtn{display: inline-block;}\r\n  div.bookdemomobbox .menuBtn a{position: relative;top: 7px;}\r\n}\r\n\r\n/*** Footer ***/\r\n\r\n.nlgradbg {\r\n  background: linear-gradient(to right,#006bc0,#691dc0)\r\n}\r\n\r\n.novus_footer{padding: 40px 0;}\r\n.novus_footer .footer_link_box{padding: 0 0 0 60px;}\r\n.novus_footer .footer_link_box ul li{margin-bottom: 15px;text-transform: uppercase;}\r\n.novus_footer .footer_link_box ul li:nth-last-child(1){margin-bottom: 0;}\r\n.novus_footer .footer_link_box ul li a{color: #000;}\r\n\r\n.footer_row{margin-top: 60px;}\r\n.footer_row h5{margin-bottom: 20px;font-weight: 700;color: #FFF}\r\n.footer_row ul li{margin: 10px 0;font-size: 16px;}\r\n.footer_row ul li a{color: #FFF;}\r\n.footer_header{display: none;}\r\n\r\n.footer_copyright{padding: 10px 0;}\r\n.footer_copyright p{margin-bottom: 0;color: #ffffff;font-family: 'Gilroy Light';}\r\n.footer_copyright ul li{display: inline-block;margin-right: 30px;color: #fff;}\r\n.footer_copyright ul li:nth-child(5){margin-right: 0;}\r\n.footer_copyright ul li a{color: #fff;}\r\n\r\n.footer_copyright_links{float: right;}\r\n// .linkedin_{background: url(../Image/linkedin.png) no-repeat;background-size:contain;width: 38px;height: 38px;display: inline-block;position: absolute;margin-top: 20px;}\r\n.pci_dss{background: url(../Image/pci-dss.png) no-repeat;width: 78px;height: 38px;display: inline-block;margin-right: 10px;}\r\n.linkedinfollow{position:relative;display: inline-block;margin-bottom: 20px;}\r\n.showonmobonly {display: none;}\r\n\r\n/*** New Footer ***/\r\n\r\n@media only screen and (min-width:769px){\r\n  .nffooterlinks,.nfcopyright{display: none;}\r\n  }\r\n  \r\n  @media only screen and (max-width:768px){\r\n    .bigspacing {padding: 40px 0;}\r\n    .hideonnewfooter{display: none;}\r\n    .nfnewsletter{margin-top: 0;}\r\n    .nfnewsletter h6{text-align: center;font-size: 18px;}\r\n    .nfnewsletter .newsletter_form input{width: 100%;padding: 15px 20px;}\r\n    .nfnewsletter .newsletter_form button{margin-top: -44px;margin-right: 10px;}\r\n    .nffooterlinks{margin-top: 20px;margin-bottom: 15px;}\r\n    .nffooterlinks ul{text-align: center;}\r\n    .nffooterlinks ul li{display: inline-block;margin-right: 20px;margin-bottom: 5px;}\r\n    .nffooterlinks ul li a{color: #FFF;font-size: 1.32rem;}\r\n    .nfcopyright{text-align: center;margin-top: 20px;}\r\n    .nfcopyright ul li{display: inline-block;margin-right: 20px;font-size: 1.5rem;color: #FFF;}\r\n    .navbar-menu ul li{display: none;}\r\n    .navbar-menu ul li.menuBtn{display: block;}\r\n    .nvsbanner{height: auto;background-position: center;margin-top: 0;padding-top: 100px;}\r\n    .nvs_banner_container{padding: 40px 20px;}\r\n    .nvs_banner_container h1{font-size: 28px;}\r\n    .footer_link_list, .boxwithcircle:before, .boxwithcirclereverse:after {display: none;}\r\n    .footer_row.row-cols-1>* {width: 50%;padding-left: 20px;}\r\n    .footer_row h5 {display: none;}\r\n    .footer_row h5.footer_header {display: block;font-size: 1.6rem;}\r\n    .hideonmob,.footer_logo_hide_on_mob {display: none;}\r\n    .footer_row {margin-top: 20px;}\r\n    .showonmobonly {display: inline-block;}\r\n    .navbar .nl_logo,.navbar.sticky .nl_logo, .navbar.white .nl_logo{width: 120px;height: 50px;background-size: contain;}\r\n  }\r\n\r\n/*** Menu Wrapper ***/\r\n\r\n@media (min-width: 769px) {\r\n  .menuWrapper{position: fixed;top: 0;left: 0;right: 0;bottom: 0;opacity: 0;z-index: 2;overflow-y: scroll;overflow-x: hidden;visibility: hidden;}\r\n  //.menuWrapper .menuInner{position: absolute;top: 0;left: 0;width: 100%;height: 100%;z-index: 1;opacity: 0;visibility: hidden;background: url(../img/menu_bg.webp) left top no-repeat #012a5e;background-size: cover;-webkit-transition: all 50ms ease-out;-o-transition: all 50ms ease-out;transition: all 50ms ease-out;-webkit-transition-delay: 0s;-o-transition-delay: 0s;transition-delay: 0s;}\r\n  .menuWrapper .circle{content: \"\";position: fixed;top: 0;right: 0;width: 60%;z-index: -1;height: 100%;background: rgba(1, 42, 94, 0.88);-webkit-transition: all 50ms cubic-bezier(0.165, 0.84, 0.44, 1);-o-transition: all 50ms cubic-bezier(0.165, 0.84, 0.44, 1);transition: all 50ms cubic-bezier(0.165, 0.84, 0.44, 1);}\r\n}\r\n@media (min-width: 769px) and (max-width: 1024px) {\r\n  .menuWrapper .circle{width: 100%;}\r\n  .nvsbofferingheadingbox,.nvsblorow{padding: 0 30px;}\r\n  .nvsbofferingbox{height: auto;}\r\n}\r\n@media (min-width: 769px) {\r\n  .menuWrapper.showMenu{opacity: 1;visibility: visible;}\r\n  .menuWrapper.showMenu .menuInner{opacity: 1;visibility: visible;-webkit-transition: all 0.8s ease-out;-o-transition: all 0.8s ease-out;transition: all 0.8s ease-out;}\r\n  .menuWrapper .navContainer{position: absolute;top: 50%;left: 45%;width: 400px;margin-top: -75px;-webkit-transform: translateY(-50%);-ms-transform: translateY(-50%);-o-transform: translateY(-50%);transform: translateY(-50%);}\r\n  .menuWrapper .navContainer ul{margin: 0;}\r\n  .menuWrapper .navContainer ul li{position: relative;z-index: 1;display: block;font-weight: 500;font-size: 40px;line-height: 60px;-webkit-transition: opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);-o-transition: opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);transition: opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);}\r\n  .menuWrapper .navContainer ul li a{display: inline-block;color: #fff;-webkit-transition: color 0.6s cubic-bezier(0.4, 0, 0.2, 1);-o-transition: color 0.6s cubic-bezier(0.4, 0, 0.2, 1);transition: color 0.6s cubic-bezier(0.4, 0, 0.2, 1);}\r\n}\r\n@media (min-width: 769px) and (max-width: 1366px) {\r\n  .menuWrapper .navContainer ul li a{padding-right: 0;}\r\n}\r\n@media (min-width: 769px) {\r\n  .menuWrapper .navContainer ul li.hasDropDown:before{content: \"\";position: absolute;top: 33px;left: 340px;width: 0;height: 1px;z-index: -1;background: #fff;-webkit-transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);-o-transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);}\r\n}\r\n@media (min-width: 769px) and (max-width: 1199px) {\r\n  .menuWrapper .navContainer ul li.hasDropDown:before{top: 27px;left: 280px;}\r\n}\r\n@media (min-width: 769px) {\r\n  .menuWrapper .navContainer ul li .dropdown{position: absolute;top: 21px;left: 100%;padding-left: 0;visibility: hidden;-webkit-transition: visibility 10ms ease-out;-o-transition: visibility 10ms ease-out;transition: visibility 10ms ease-out;-webkit-transition-delay: 0.8s;-o-transition-delay: 0.8s;transition-delay: 0.8s;}\r\n  .menuWrapper .navContainer ul li .dropdown.adjustUpSide{top: -75px;}\r\n  .menuWrapper .navContainer ul li .dropdown.adjustUpSide2{top: auto;bottom: 0;}\r\n  .menuWrapper .navContainer ul li .dropdown li{font-weight: 500;font-size: 16px;opacity: 0;margin: 0 0 20px;text-align: left;line-height: 24px;white-space: nowrap;text-transform: none;-webkit-transform: translateX(-30%);-ms-transform: translateX(-30%);-o-transform: translateX(-30%);transform: translateX(-30%);-webkit-transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1), transform 0.45s cubic-bezier(0.4, 0, 0.2, 1);-o-transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1), transform 0.45s cubic-bezier(0.4, 0, 0.2, 1);transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1), transform 0.45s cubic-bezier(0.4, 0, 0.2, 1);}\r\n  .menuWrapper .navContainer ul li .dropdown li:before{display: none;}\r\n  .menuWrapper .navContainer ul li .dropdown li:nth-child(1){-webkit-transition-delay: 780ms;-o-transition-delay: 780ms;transition-delay: 780ms;}\r\n  .menuWrapper .navContainer ul li .dropdown li:nth-child(2){-webkit-transition-delay: 740ms;-o-transition-delay: 740ms;transition-delay: 740ms;}\r\n  .menuWrapper .navContainer ul li .dropdown li:nth-child(3){-webkit-transition-delay: 0.7s;-o-transition-delay: 0.7s;transition-delay: 0.7s;}\r\n  .menuWrapper .navContainer ul li .dropdown li:nth-child(4){-webkit-transition-delay: 660ms;-o-transition-delay: 660ms;transition-delay: 660ms;}\r\n  .menuWrapper .navContainer ul li .dropdown li:nth-child(5){-webkit-transition-delay: 620ms;-o-transition-delay: 620ms;transition-delay: 620ms;}\r\n  .menuWrapper .navContainer ul li .dropdown li:nth-child(6){-webkit-transition-delay: 540ms;-o-transition-delay: 540ms;transition-delay: 540ms;}\r\n  .menuWrapper .navContainer ul li .dropdown li:nth-child(7){-webkit-transition-delay: 520ms;-o-transition-delay: 520ms;transition-delay: 520ms;}\r\n  .menuWrapper .navContainer ul li .dropdown li:nth-child(8){-webkit-transition-delay: 480ms;-o-transition-delay: 480ms;transition-delay: 480ms;}\r\n  .menuWrapper .navContainer ul li .dropdown li:nth-child(9){-webkit-transition-delay: 440ms;-o-transition-delay: 440ms;transition-delay: 440ms;}\r\n  .menuWrapper .navContainer ul li .dropdown li:nth-child(10){-webkit-transition-delay: 0.4s;-o-transition-delay: 0.4s;transition-delay: 0.4s;}\r\n  .menuWrapper .navContainer ul li .dropdown li:nth-child(11){-webkit-transition-delay: 360ms;-o-transition-delay: 360ms;transition-delay: 360ms;}\r\n  .menuWrapper .navContainer ul li .dropdown li:nth-child(12){-webkit-transition-delay: 320ms;-o-transition-delay: 320ms;transition-delay: 320ms;}\r\n  .menuWrapper .navContainer ul li .dropdown li a{background: 0 0;}\r\n}\r\n@media (min-width: 769px) and (max-width: 1366px) {\r\n  .menuWrapper .navContainer ul li .dropdown li{font-size: 15px;}\r\n}\r\n@media (min-width: 769px) and (max-width: 1199px) {\r\n  .menuWrapper .navContainer ul li .dropdown{top: 15px;}\r\n}\r\n@media (min-width: 769px){\r\n  .menuWrapper .navContainer ul li:hover.hasDropDown:before{width: 40px;}\r\n  .menuWrapper .navContainer ul li:hover a{color: #fff;}\r\n  .menuWrapper .navContainer ul li:hover .dropdown{visibility: visible;-webkit-transition-delay: 10ms;-o-transition-delay: 10ms;transition-delay: 10ms;}\r\n  .menuWrapper .navContainer ul li:hover .dropdown li{opacity: 1;-webkit-transform: translateX(0);-ms-transform: translateX(0);-o-transform: translateX(0);transform: translateX(0);}\r\n  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(1) {\r\n      -webkit-transition-delay: 340ms;\r\n      -o-transition-delay: 340ms;\r\n      transition-delay: 340ms;\r\n  }\r\n  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(2) {\r\n      -webkit-transition-delay: 380ms;\r\n      -o-transition-delay: 380ms;\r\n      transition-delay: 380ms;\r\n  }\r\n  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(3) {\r\n      -webkit-transition-delay: 420ms;\r\n      -o-transition-delay: 420ms;\r\n      transition-delay: 420ms;\r\n  }\r\n  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(4) {\r\n      -webkit-transition-delay: 460ms;\r\n      -o-transition-delay: 460ms;\r\n      transition-delay: 460ms;\r\n  }\r\n  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(5) {\r\n      -webkit-transition-delay: 0.5s;\r\n      -o-transition-delay: 0.5s;\r\n      transition-delay: 0.5s;\r\n  }\r\n  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(6) {\r\n      -webkit-transition-delay: 540ms;\r\n      -o-transition-delay: 540ms;\r\n      transition-delay: 540ms;\r\n  }\r\n  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(7) {\r\n      -webkit-transition-delay: 580ms;\r\n      -o-transition-delay: 580ms;\r\n      transition-delay: 580ms;\r\n  }\r\n  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(8) {\r\n      -webkit-transition-delay: 620ms;\r\n      -o-transition-delay: 620ms;\r\n      transition-delay: 620ms;\r\n  }\r\n  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(9) {\r\n      -webkit-transition-delay: 660ms;\r\n      -o-transition-delay: 660ms;\r\n      transition-delay: 660ms;\r\n  }\r\n  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(10) {\r\n      -webkit-transition-delay: 0.7s;\r\n      -o-transition-delay: 0.7s;\r\n      transition-delay: 0.7s;\r\n  }\r\n  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(11) {\r\n      -webkit-transition-delay: 740ms;\r\n      -o-transition-delay: 740ms;\r\n      transition-delay: 740ms;\r\n  }\r\n  .menuWrapper .navContainer ul li:hover .dropdown li:nth-child(12) {\r\n      -webkit-transition-delay: 780ms;\r\n      -o-transition-delay: 780ms;\r\n      transition-delay: 780ms;\r\n  }\r\n  .menuWrapper .navContainer ul li:hover .dropdown:hover li a{opacity: 0.6;}\r\n  .menuWrapper .navContainer ul li:hover .dropdown:hover li a:hover{opacity: 1;}\r\n}\r\n@media (min-width: 769px) and (max-width: 1199px) {\r\n  .menuWrapper .navContainer ul li{font-size: 33px;line-height: 60px;}\r\n}\r\n@media (min-width: 769px) {\r\n  .menuWrapper .navContainer ul:hover li.hasDropDown{opacity: 0.6;}\r\n  .menuWrapper .navContainer ul:hover li.hasDropDown:hover{opacity: 1;}\r\n}\r\n@media (min-width: 769px) and (max-width: 1199px) {\r\n  .menuWrapper .navContainer{width: 350px;}\r\n  .blcontained{width: 100%;margin: 0 auto;}\r\n}\r\n@media (min-width: 769px) and (max-width: 1024px) {\r\n  .menuWrapper .navContainer{left: 80px;}\r\n}\r\n@media (max-width: 768px) {\r\n  .menuWrapper {position: fixed;top: 0;left: 0;bottom: 0;width: 100%;z-index: 99;visibility: hidden;-webkit-transition: visibility 850ms ease-out;-o-transition: visibility 850ms ease-out;transition: visibility 850ms ease-out;}\r\n  .menuWrapper:before {position: absolute;content: \"\";top: 0;left: 0;right: 0;bottom: 0;z-index: 1;background: #000;-webkit-transform: scaleX(0);-ms-transform: scaleX(0);-o-transform: scaleX(0);transform: scaleX(0);-webkit-transform-origin: center left;-ms-transform-origin: center left;-o-transform-origin: center left;transform-origin: center left;-webkit-transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);-o-transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);-webkit-transition-delay: 250ms;-o-transition-delay: 250ms;transition-delay: 250ms;display: none;}\r\n  .menuWrapper:after{position: absolute;content: \"\";top: 0;left: 0;width: 96%;z-index: 3;bottom: 0;background: rgba(13, 67, 136, 0.96);-webkit-transform: scaleX(0);-ms-transform: scaleX(0);-o-transform: scaleX(0);transform: scaleX(0);-webkit-transform-origin: center left;-ms-transform-origin: center left;-o-transform-origin: center left;transform-origin: center left;-webkit-transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);-o-transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);-webkit-transition-delay: 0.1s;-o-transition-delay: 0.1s;transition-delay: 0.1s;}\r\n  .menuWrapper .menuInner {position: relative;z-index: 100;height: 100%;}\r\n  .menuWrapper .menuInner .navContainer{height: 100%;overflow: auto;padding: 150px 0 60px;-webkit-transform: translateX(-100%);-ms-transform: translateX(-100%);-o-transform: translateX(-100%);transform: translateX(-100%);-webkit-transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);-o-transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);-webkit-transition-delay: 0.4s;-o-transition-delay: 0.4s;transition-delay: 0.4s;}\r\n  .menuWrapper .menuInner .navContainer ul{padding: 0;}\r\n  .menuWrapper .menuInner .navContainer ul li{display: block;font-size: 30px;line-height: 60px;}\r\n  .menuWrapper .menuInner .navContainer ul li a{display: inline-block;color: #fff;padding: 0 30px;}\r\n  .menuWrapper .menuInner .navContainer ul li .dropdown{display: none;padding-left: 15px;}\r\n  .menuWrapper .menuInner .navContainer ul li .dropdown li{font-size: 16px;opacity: 0.8;line-height: 30px;}\r\n  .menuWrapper .menuInner .navContainer ul li.active .dropdown{display: block;}\r\n  .menuWrapper .menuInner .addressBox{padding: 0;opacity: 0;-webkit-transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);-o-transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);-webkit-transition-delay: 0.6s;-o-transition-delay: 0.6s;transition-delay: 0.6s;}\r\n  .menuWrapper .menuInner .addressBox .atext,.menuWrapper .menuInner .addressBox .rightBox{display: none;}\r\n  .menuWrapper .menuInner .addressBox .follow{padding: 11px 30px;}\r\n  .menuWrapper .menuInner .addressBox .follow h4{float: left;margin: 0;width: 50%;font-family: proxima_novaregular;color: #fff;line-height: 28px;letter-spacing: 1px;text-transform: uppercase;}\r\n  .menuWrapper .menuInner .addressBox .follow ul{padding: 0;margin: 0;width: 50%;float: right;text-align: right;}\r\n  .menuWrapper .menuInner .addressBox .follow ul li{display: inline-block;font-size: 18px;margin: 0 10px;line-height: 28px;}\r\n  .menuWrapper .menuInner .addressBox .follow ul li a{color: #fff;display: block;}\r\n  .nav-active .menuWrapper{opacity: 1;visibility: visible;transition-delay: 0s;}\r\n  .nav-active .menuWrapper:before {-webkit-transform: scaleX(1);-ms-transform: scaleX(1);transform: scaleX(1);transition-delay: 0.2s;}\r\n  .nav-active .menuWrapper:after{-webkit-transform: scaleX(1);-ms-transform: scaleX(1);transform: scaleX(1);transition-delay: 0.3s;}\r\n  .nav-active .menuWrapper .addressBox,.nav-active .menuWrapper .navContainer{opacity: 1;-webkit-transform: translateX(0);-ms-transform: translateX(0);-o-transform: translateX(0);transform: translateX(0);}\r\n}\r\n\r\n.navbar .menuBtn{float: none !important;margin: 0 0 0 10px;display: none;}\r\n@media (max-width: 480px) {\r\n  .navbar .menuBtn {margin: 0 10px;}\r\n}\r\n\r\n@media (max-width: 360px){\r\n  .navbar .menuBtn {\r\n      margin: 0 5px;\r\n  }\r\n}\r\n.navbar .menuBtn a{position: relative;width: 33px;height: 26px;cursor: pointer;display: block;z-index: 999999999999;-webkit-transition: all 20ms cubic-bezier(0.4, 0, 0.2, 1);-o-transition: all 20ms cubic-bezier(0.4, 0, 0.2, 1);transition: all 20ms cubic-bezier(0.4, 0, 0.2, 1);-webkit-transition-delay: 0.1s;-o-transition-delay: 0.1s;transition-delay: 0.1s;}\r\n.navbar .menuBtn span{position: absolute;top: 0;left: 0;display: block;width: 33px;height: 3px;z-index: 1;background: #fff;-webkit-transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);-o-transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);}\r\n.navbar .menuBtn.new_btn span{background-color: #FFF;}\r\n.navbar .menuBtn span:last-child{top: 22px;}\r\n.navbar .menuBtn span.cross{top: 10px;left: 7px;z-index: 2;background: 0 0;}\r\n.navbar .menuBtn span.cross:after,.navbar .menuBtn span.cross:before {display: block;content: \"\";position: absolute;top: 50%;left: 0;width: 100%;height: 3px;background: #fff;-webkit-transition: all 350ms cubic-bezier(0.4, 0, 0.2, 1);-o-transition: all 350ms cubic-bezier(0.4, 0, 0.2, 1);transition: all 350ms cubic-bezier(0.4, 0, 0.2, 1);}\r\n.navbar .menuBtn.new_btn span.cross:after, .navbar .menuBtn.new_btn span.cross:before{background-color: #FFF;}\r\n.navbar .menuBtn:hover span.cross{left: 0;}\r\n.navbar .menuBtn .is-active span:first-child{opacity: 0;}\r\n.navbar .menuBtn .is-active span:last-child{opacity: 0;}\r\n.navbar .menuBtn .is-active span.cross{height: 26px;top: 0;left: 0;}\r\n.navbar .menuBtn .is-active span.cross:before{-webkit-transform: rotate(-45deg);-ms-transform: rotate(-45deg);-o-transform: rotate(-45deg);transform: rotate(-45deg);}\r\n.navbar .menuBtn .is-active span.cross:after {  -webkit-transform: rotate(45deg);  -ms-transform: rotate(45deg);  -o-transform: rotate(45deg);  transform: rotate(45deg);}\r\n.navbar.sticky .menuBtn span,.navbar.white .menuBtn span {background: #012a5e;}\r\n.navbar.sticky .menuBtn span.cross,.navbar.white .menuBtn span.cross {background: 0 0;}\r\n.navbar.sticky .menuBtn span.cross:after,.navbar.sticky .menuBtn span.cross:before,.navbar.white .menuBtn span.cross:after,.navbar.white .menuBtn span.cross:before{background: #012a5e;}\r\n.navbar.sticky .menuBtn a.is-active span,.navbar.white .menuBtn a.is-active span {background: #fff;}\r\n.navbar.sticky .menuBtn a.is-active span.cross,.navbar.white .menuBtn a.is-active span.cross {background: 0 0;}\r\n.navbar.sticky .menuBtn a.is-active span.cross:after,.navbar.sticky .menuBtn a.is-active span.cross:before,.navbar.white .menuBtn a.is-active span.cross:after,.navbar.white .menuBtn a.is-active span.cross:before {background: #fff;}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
